import {
  Checkbox,
  Icon,
  IconButton,
  LoadingIndicator,
  Tag,
} from '@monash/portal-react';
import classNames from 'classnames';
import { getTagText } from '../../utilities/get-tag-text';
import { TAG_COLORS } from '../../../constants/tag-colors';
import c from './item-details.module.scss';

const ItemDetails = ({
  title,
  label,
  status,
  publishDate,
  labelLineBreak = true,
  setExpanded,
  expanded,
  isLoading,
  error,
  handleCheck,
  checked,
}) => {
  const tagText = getTagText({ status, publishDate });
  const labelClasses = classNames(c.label, {
    [c.lineBreak]: labelLineBreak,
    [c.hasCheckbox]: handleCheck,
  });

  return (
    <>
      <div className={c.title}>
        <div className={c.labelWrapper}>
          {handleCheck && (
            <div
              onClick={(e) =>
                // stop the checkbox from opening the slideout menu
                e.stopPropagation()
              }
            >
              <Checkbox onChange={handleCheck} on={checked} />
            </div>
          )}

          <h3>{title}</h3>
        </div>
        <div className={c.labelWrapper}>
          <Tag color={TAG_COLORS[status]} text={tagText} />
          {setExpanded && (
            <IconButton
              icon={expanded ? Icon.ChevronUp : Icon.ChevronDown}
              aria-label={expanded ? 'Collapse' : 'Expand'}
              color="var(--card-text-color)"
              onClick={(e) => {
                e.stopPropagation();
                setExpanded((f) => !f);
              }}
            />
          )}
          {isLoading && <LoadingIndicator />}
          {error && (
            <div className={c.error}>
              <Icon.Warning />
              <span>{error}</span>
            </div>
          )}
        </div>
      </div>

      {label && <span className={labelClasses}>{label}</span>}
    </>
  );
};

export default ItemDetails;
